export interface IntegerResultAndStringResultDTO {
  integerResult: number;
  stringResult : string;
};

export function IntegerResultAndStringResultDTO_EmptyObject(): IntegerResultAndStringResultDTO {
  return {
    integerResult: 0,
    stringResult : ""
  }
};
